import React from "react";

export const Kurs = (props) => {
  const { kurs, kondition, locale } = props || {};
  if (!kurs || !kondition || !kurs[kondition.col]) return null;
  let value = Number(kurs[kondition.col]).toLocaleString(locale || "de-DE", {
    style: "decimal",
    minimumFractionDigits: 3
  });

  return (
    <div className="d-flex justify-content-between">
      <div className="pe-one">Kurs:</div>
      <span>{value}</span>
    </div>
  );
};
